
import {React, component} from './component';
import './LinkButton';

import Link from './Link';
import {ArrowRight} from './icons';
import Ellipsis from './MultilineEllipsis';

import emptyPic from './emptyPic';

const TYPES = {

  horizontal({image, description, url, imageType, logo}) {
    const imageSrc = imageType === 'logo' ? logo : image;
    return (
      <div className='Banner Banner--Horizontal'>
        <img className='Banner-Image' src={imageSrc || emptyPic} />
        <h2 className="Banner-Description">
          <Ellipsis className="Banner-DescriptionEllipsis">
            {description}
          </Ellipsis>
        </h2>
        <Link className='LinkButton' href={url}>
          <div className='LinkButton-Text'>Подробности</div>
          <ArrowRight className='LinkButton-Arrow' />
        </Link>
      </div>
    );
  },

  vertical({image, description, url, width, height}) {
    return (
      <div className='Banner Banner--Vertical'>
        <Link href={url}>
          <img className='Banner-Image' src={image || emptyPic} width={width} height={height} />
          <div className='Banner-Caption'>{description}</div>
        </Link>
      </div>
    );
  }

};

export default component('Banner', {

  propTypes: {
    width: React.PropTypes.number,
    height: React.PropTypes.number,
    type: React.PropTypes.oneOf(Object.keys(TYPES)).isRequired,
    imageType: React.PropTypes.oneOf(['logo', 'image']),
    data: React.PropTypes.object.isRequired
  },

  render() {
    const {data, type, width, height, imageType} = this.props;
    const banner = data.toJS();
    if (!banner) {
      return null;
    }
    const renderer = TYPES[type];
    if (!renderer) {
      return null;
    }
    return renderer({...banner, width, height, imageType});
  }

});




// WEBPACK FOOTER //
// ./src/components/Banner.js